module.exports = __webpack_public_path__ + "static/media/bikeNewKTM.7e43b60d.svg";